import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../../i18n';

/**
 * @summary LicenseInfoRow
 * @extends {AoflElement}
 */
@customElement('license-info-row')
class LicenseInfoRow extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of LicenseInfoRow.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  @property({type: Object})
  row = {};

  @property({type: Array, attribute: true})
  styles = [];

  @property({type: Boolean})
  loading = false;

  /**
   * @readonly
   */
  static is = 'license-info-row';
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles, ...this.styles]
      }
    });
  }
}

export default LicenseInfoRow;
